module.exports = __webpack_public_path__ + "static/image-scale-2dfc022dd0de81a35b23f6c3a917b8f9.png";